import { render } from "./ClassInfo.vue?vue&type=template&id=2f61cb4c&scoped=true"
import script from "@/assets/js/ClassInfo.js?vue&type=script&lang=js"
export * from "@/assets/js/ClassInfo.js?vue&type=script&lang=js"

import "./ClassInfo.vue?vue&type=style&index=0&id=2f61cb4c&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f61cb4c"]])

export default __exports__